module.exports = __webpack_public_path__ + "3440d019a03d2b4c0b65c5e7c9177e85.woff";


//////////////////
// WEBPACK FOOTER
// ./src/css/commit/font/iconfont.woff?t=1551778644856
// module id = 822
// module chunks = 9